import { useEffect, useState } from 'react'

import { getRequestPhase } from '../../../../../api'
import { useUserData } from '../../../../../hooks'
import { isStaffUser } from '../../../../../utils/user'
import { getRequestProfileHeaderInfoItemsPreparedPhases } from '../useRequestProfileHeaderInfoItems'

export function useRequestProfileHeaderPhases({ outboundUuid, requestId }) {
  const currentUser = useUserData()
  const isStaff = isStaffUser(currentUser)

  // The profile stays mounted across request navigation, so tag loaded phases
  // with their request — a late/stale response for a previous request is ignored.
  const [loaded, setLoaded] = useState(null)

  async function handleLoadRequestPhases() {
    // #INFO Connected (iDWELL-to-iDWELL) requests have no header pipeline; their
    // Activities tab loads phases separately via the id2id endpoint.
    if (outboundUuid) {
      return Promise.resolve(null)
    }

    return getRequestPhase({ id: requestId })
      .then(({ data }) => {
        setLoaded({
          phases: getRequestProfileHeaderInfoItemsPreparedPhases(data),
          requestId,
        })

        return data
      })
      .catch(() => {
        setLoaded({ phases: null, requestId })
      })
  }

  useEffect(() => {
    if (requestId && isStaff) {
      handleLoadRequestPhases()
    }
  }, [isStaff, requestId])

  const isLoadedForCurrentRequest =
    loaded !== null && loaded.requestId === requestId
  const phases = isLoadedForCurrentRequest ? loaded.phases : null
  const arePhasesLoading =
    isStaff && !outboundUuid && Boolean(requestId) && !isLoadedForCurrentRequest

  return {
    arePhasesLoading,
    handleReloadRequestPhases: handleLoadRequestPhases,
    phases,
  }
}
